var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "item-container" }, [_vm.resource.file_type === 'audio' ? _c('audio-container', { ref: "audioContainer", attrs: { "url": _vm.resource.file_url, "file-meta": {
        id: _vm.resource.id,
        name: _vm.resource.name || _vm.resource.file_origin_name + (_vm.index + 1),
        name_en: _vm.resource.name_en || _vm.resource.file_origin_name + (_vm.index + 1),
        useTimes: _vm.resource.use_times,
        updated_time: _vm.resource.updated_time,
        duration: _vm.resource.duration,
        tag_names: _vm.resource.tag_names
      }, "file-meta-style": {
        maxHeight: '68px',
        width: '100%'
      }, "audioStyle": _vm.imageStyle, "autoPlayWhenHover": true } }) : _vm._e(), _vm._v(" "), _vm.resource.file_type === 'video' ? _c('video-container', { attrs: { "url": _vm.resource.file_url, "cover": _vm.resource.image_url, "file-meta": {
        id: _vm.resource.id,
        name: _vm.resource.name,
        name_en: _vm.resource.name_en,
        width: _vm.dimensionWidth,
        height: _vm.dimensionHeight,
        useTimes: _vm.resource.use_times,
        updated_time: _vm.resource.updated_time,
        tag_names: _vm.resource.tag_names,
        duration: _vm.resource.duration
      }, "file-meta-style": {
        maxHeight: '68px',
        width: '100%'
      }, "videoStyle": _vm.imageStyle } }) : _vm._e(), _vm._v(" "), _vm.resource.file_type === 'image' ? _c('image-container', { attrs: { "url": _vm.imageUrl, "file-meta": {
        id: _vm.resource.id,
        name: _vm.resource.name,
        name_en: _vm.resource.name_en,
        width: _vm.dimensionWidth,
        height: _vm.dimensionHeight,
        useTimes: _vm.resource.use_times,
        updated_time: _vm.resource.updated_time,
        tag_names: _vm.resource.tag_names,
        cat1_name: _vm.resource.res_type === 18 ? '' : _vm.resource.cat1_name,
        cat2_name: _vm.resource.res_type === 18 ? '' : _vm.resource.cat2_name
      }, "file-meta-style": {
        maxHeight: '68px',
        width: '100%'
      }, "imageStyle": _vm.imageStyle } }) : _vm._e(), _vm._v(" "), _vm.resource.file_type === 'sequence-frame' ? _c('sequence-frame-container', { attrs: { "images": _vm.resource.preview_urls || [], "file-meta": {
        id: _vm.resource.id,
        name: _vm.resource.name,
        name_en: _vm.resource.name_en,
        width: _vm.dimensionWidth,
        height: _vm.dimensionHeight,
        fileSize: _vm.resource.file_size,
        useTimes: _vm.resource.use_times,
        updated_time: _vm.resource.updated_time,
        tag_names: _vm.resource.tag_names,
        cat1_name: _vm.resource.cat1_name,
        cat2_name: _vm.resource.cat2_name
      }, "file-meta-style": {
        maxHeight: '68px',
        width: '100%'
      }, "frame-sequence-container-style": _vm.imageStyle, "frame-sequence-style": {
        width: _vm.dimensionWidth / 2 + 'px',
        height: _vm.dimensionHeight / 2 + 'px'
      } } }) : _vm._e()], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };